// 获取顶层对象
var getGlobal = function() {
	if (typeof self !== 'undefined') {
		return self
	}
	if (typeof window !== 'undefined') {
		return window
	}
	if (typeof global !== 'undefined') {
		return global
	}
	throw new Error('unable to locate global object')
}
const domain = 'http'
// const devHost = 'ydyss.cptchina.cn'
const devHost = '192.168.3.36'

// const devHost = '192.168.1.6'

// const devPort = '3370'
// const localHost = '192.168.0.121'
// const localHost = '192.168.1.2'
const localHost = '192.168.10.41'

const localPort = '8080'
console.log(getGlobal().$URL)
//
const proPort = '3370'
const devUrl = domain + '://' + devHost
const proUrl = getGlobal().$URL
const localUrl = domain + '://' + localHost + ':' + localPort

module.exports = {
	domain: domain,
	proPort: proPort,
	localPort: localPort,
	localHost: localHost,
	devUrl: devUrl,
	localUrl: localUrl,
	proUrl: proUrl,
}



// WEBPACK FOOTER //
// ./src/request/globalApi.js